module.exports = __webpack_public_path__ + "static/img/img_cat_taking_picture.b2ce3c5.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/img_cat_taking_picture.png
// module id = 554
// module chunks = 1